import React, { lazy, Suspense } from 'react';

import { MainLoadingIndicator } from '../components/MainLoadingIndicator';

const MapContainer = lazy(() => import('../features/map/MapContainer'));
const Table = lazy(() => import('../features/table/Table'));

type MainPagesProps = {
    isMap: boolean;
    hasMapAlreadyLoaded: boolean;
};

// Initialize and render the map container only once and when navigating to list view just hide the map
// as it's expensive to initialize and add the map again to the DOM
// However, when initial page is the table, don't load the map until the user has clicked on the map button.
// This will save loading performance, especially when having larger fleets
export const MainPages = ({ isMap, hasMapAlreadyLoaded }: MainPagesProps) => {
    const showMap = isMap;
    const isOffscreen = !showMap && hasMapAlreadyLoaded;

    return (
        <React.Fragment>
            {!showMap && (
                <Suspense fallback={<MainLoadingIndicator />}>
                    <Table />
                </Suspense>
            )}
            {(showMap || isOffscreen) && (
                <Suspense fallback={<MainLoadingIndicator />}>
                    <MapContainer className={`${isOffscreen ? 'position-offscreen' : ''}`} />
                </Suspense>
            )}
        </React.Fragment>
    );
};
